import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Highlight from './common/js/Highlight.js'
import ElementUI from 'element-ui'
import Moment from 'moment'
import 'element-ui/lib/theme-default/index.css'
import 'font-awesome/css/font-awesome.css'
import VDistpicker from 'v-distpicker'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VDistpicker)
Vue.use(VueQuillEditor)
Vue.use(ElementUI)
Vue.use(Highlight)

Vue.config.productionTip = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

// 定义全局时间戳过滤器
Vue.filter('formatDate', function (value) {
  if (value) {
    return Moment(value).format('YYYY-MM-DD')
  } else {
    return ''
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return Moment(value).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return ''
  }
})



// WEBPACK FOOTER //
// ./src/main.js